import React, { useState } from 'react'

import { Auth } from '../../amplify'
import parseUsername from '../utils/parseUsername'
import { useAuthScreenStyles } from './authScreenStyles'

export default function CustomForgotPassword({ initialUsername = '', onBack }) {
  const classes = useAuthScreenStyles()
  const [username, setUsername] = useState(initialUsername)
  const [code, setCode] = useState('')
  const [password, setPassword] = useState('')
  const [codeSent, setCodeSent] = useState(false)
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState('')

  const normalizedUsername = parseUsername(username || '').toLowerCase()

  const sendCode = async event => {
    event.preventDefault()
    setLoading(true)
    setError('')
    try {
      await Auth.forgotPassword(normalizedUsername)
      setCodeSent(true)
    } catch (err) {
      setError(err.message || 'Could not send the reset code.')
    } finally {
      setLoading(false)
    }
  }

  const submitReset = async event => {
    event.preventDefault()
    setLoading(true)
    setError('')
    try {
      await Auth.forgotPasswordSubmit(normalizedUsername, code, password)
      onBack()
    } catch (err) {
      setError(err.message || 'Could not reset the password.')
    } finally {
      setLoading(false)
    }
  }

  return (
    <div className={classes.page}>
      <div className={classes.card}>
        <img className={classes.logo} src="/assets/icons/blue-logo.svg" alt="Civic Champs" />
        <h3 className={classes.header}>Reset your password</h3>
        <form onSubmit={codeSent ? submitReset : sendCode}>
          {codeSent ? (
            <>
              <div className={classes.field}>
                <label className={classes.label} htmlFor="admin-reset-code">
                  Code *
                </label>
                <input
                  id="admin-reset-code"
                  className={classes.input}
                  placeholder="Enter your code"
                  autoComplete="one-time-code"
                  autoFocus
                  required
                  value={code}
                  onChange={e => setCode(e.target.value)}
                />
              </div>
              <div className={classes.field}>
                <label className={classes.label} htmlFor="admin-reset-password">
                  New Password *
                </label>
                <input
                  id="admin-reset-password"
                  className={classes.input}
                  type="password"
                  placeholder="Enter your new password"
                  autoComplete="new-password"
                  required
                  value={password}
                  onChange={e => setPassword(e.target.value)}
                />
                <p className={classes.hint}>
                  Lost your code?{' '}
                  <button type="button" className={classes.link} onClick={sendCode}>
                    Resend code
                  </button>
                </p>
              </div>
            </>
          ) : (
            <div className={classes.field}>
              <label className={classes.label} htmlFor="admin-reset-username">
                Username *
              </label>
              <input
                id="admin-reset-username"
                className={classes.input}
                placeholder="Enter your username"
                autoCapitalize="none"
                autoCorrect="off"
                spellCheck="false"
                autoComplete="username"
                autoFocus
                required
                value={username}
                onChange={e => setUsername(e.target.value)}
              />
            </div>
          )}
          {error && <p className={classes.error}>{error}</p>}
          <div className={classes.footer}>
            <span className={classes.footerSecondary}>
              <button type="button" className={classes.link} onClick={onBack}>
                Back to Sign In
              </button>
            </span>
            <button type="submit" className={classes.submit} disabled={loading}>
              {codeSent ? 'Submit' : 'Send Code'}
            </button>
          </div>
        </form>
      </div>
    </div>
  )
}
